export default __webpack_public_path__ + "static/product_321-407027c678e4eb50e5c56f4169625662.jpg";